import { useParams } from 'react-router-dom'
import { NavigationPage } from '@/app/components'
import { useNavigation } from '@/app/hooks'
import { LoadingAnimation, Text } from '@/components'
import PlugSessionDetail from './PlugSessionDetail'
import useDetailViewModel from './useDetailViewModel'

/**
 * Routed detail page (L2) for a single plug session: /plug-sessions/:id/details.
 * Navigating here leaves the dashboard; NavigationPage's back returns to it.
 * Ownership is enforced by the API — the plug sessions queryset is scoped to
 * the authenticated user, so foreign session ids resolve to notFound here.
 */
export default function PlugSessionDetailPage() {
  const { id } = useParams<{ id: string }>()
  const navigation = useNavigation()
  const { session, isLoading, notFound } = useDetailViewModel({
    id: Number(id),
  })

  // No subtitle: the Start/End Date rows carry the dates now
  return (
    <NavigationPage id="plug-session-detail" title="Charge Session Details">
      {isLoading ? (
        <div className="flex items-center justify-center w-full py-12">
          <LoadingAnimation type="falling" />
        </div>
      ) : notFound || !session ? (
        <Text variant="body2">
          We couldn&apos;t find that charge session. It may have been removed,
          or the link may be incorrect.
        </Text>
      ) : (
        <PlugSessionDetail
          session={session}
          onUpdateSettings={() =>
            navigation.push(
              `/devices/vehicle/${session.vehicle_id}/scheduling?tab=settings`,
            )
          }
        />
      )}
    </NavigationPage>
  )
}
